export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-page-csv-963ba9dcb59bf509bb09893abebecf06.svg";